import { AnyAction } from '@reduxjs/toolkit'

import {
  CLAIM_ERROR,
  CLAIM_REQUESTING,
  CLAIM_SUCCESS,
  DISABLE_INPUTS
} from './claim-constants'
import type { ClaimState } from './types'

const initState: ClaimState = {
  requesting: false,
  valid: false,
  claimDetails: {
    claim: '',
    dateOfLoss: '',
    professionals: [],
    lob: ''
  },
  disableInputs: false
}

const claimReducer = (state = initState, action: AnyAction) => {
  switch (action.type) {
    case CLAIM_REQUESTING:
      return {
        ...state,
        requesting: true
      }
    case CLAIM_SUCCESS:
      return {
        ...state,
        requesting: false,
        valid: true,
        claimDetails: action.claimDetails
      }
    case CLAIM_ERROR:
      return {
        ...state,
        requesting: false,
        valid: false
      }
    case DISABLE_INPUTS:
      return { ...state, disableInputs: action.disable }
    default:
      return state
  }
}
export{
  claimReducer,
  initState
}
